import { makeStyles } from "@material-ui/styles"
import { CELL_HEIGHTS, CELL_WIDTHS } from "@utils";

const useStyle = makeStyles(() => ({
  labelContainer: {
    height: CELL_HEIGHTS.XXLARGE * 4,
  },
  labelCell: {
    width: CELL_WIDTHS.VALUE.XLARGE,
    minHeight: CELL_HEIGHTS.XXLARGE,
    position: "relative",
    top: -(CELL_HEIGHTS.XXLARGE / 2),
  }
}));

export default useStyle;